<template>
    <div class="container">
        <div class="col-md-12">
            <h2> {{ labels.title }} </h2>
        </div>
        <div class="row d-flex justify-content-end col-md-2">
            <b-input-group class="mb-3" size="sm">
                <b-form-input
                    v-model="filtroContrato"
                    placeholder="Buscar por contrato"
                    debounce="100"
                    class="form-control"
                ></b-form-input>
            </b-input-group>
        </div>
        <div class="row col-md-12 justify-content-center mt-2" v-if="listContratos != 0">
            <b-table
                :items="listContratos"
                :fields="fields"
                hover
                bordered
                responsive
                sticky-header="500px"
                small
                class="tblEstandar"
                head-variant="custom-blue"
                :per-page="perPage"
                :current-page="currentPage"
                :filter="filtroContrato"
                :filter-function="filtrarPorContrato"
                @row-clicked="(item) => detalleContrato(item.id,item.nro_contrato)"
            >
                <template #cell(nro_contrato)="data">
                    <div class="text-right">{{ data.item.nro_contrato }}</div>
                </template>
                <template #cell(identificacion)="data">
                    <div class="text-left">{{ showArrendador(data.item.identificacion) }}</div>
                </template>
                <template #cell(tipo_contrato)="data">
                    <div class="text-left">{{ showTipoContrato(data.item.tipo_contrato) }}</div>
                </template>
                <template #cell(valor_contrato)="data">
                    <div class="text-right">{{ formatNumber(data.item.valor_contrato) }}</div>
                </template>
                <template #cell(estado)="data">
                    <div class="text-left">{{ data.item.estado == 'Inicial' ? 'Vigente' : data.item.estado }}</div>
                </template>
            </b-table>
            <div class="row col-12 mt-1">
                <div class="col-10 d-flex justify-content-center">
                    <b-pagination
                    v-model="currentPage"
                    :total-rows="filteredRows"
                    :per-page="perPage"
                    align="center"
                    size="md"
                    class="custom-pagination"
                    ></b-pagination>
                </div>
                <div class="col-2 d-flex justify-content-end">
                    <label class="mr-2 mb-0">Filas por página:</label>
                    <b-form-select
                    v-model="perPage"
                    :options="[5, 10, 20, 50, 100, 500]"
                    size="sm"
                    style="width: 80px;"
                    ></b-form-select>
                </div>
            </div>
        </div>
        <div class="row col-md-12 justify-content-center mt-3" v-else>
            <h5>{{ labels.noRow }}</h5>
        </div>
        <!-- <Crear :modalCrear="showCreaContrato" @cierraModal="closeModal"></Crear> -->
        <Detalle :modalDetalle="showDetalleContrato" :infoContrat="detailContrato" @cierraModal="closeModal"></Detalle>
        <ModTerminaContrato :modTermContr="showModTermContracto" :nroContrato="numContrato" @cierraModal="closeModal"></ModTerminaContrato>
    </div>
</template>

<script>
import Contrato from '../../services/Contrato';
import Tercero from '../../services/Tercero';
import TipoContrato from '../../services/TipoContrato'
// import Crear from './Crear.vue';
import Detalle from './Detalle.vue';
import ModTerminaContrato from './ModTerminaContrato.vue';

export default {
    name: 'Consultar',
    components : {
        // Crear,
        Detalle,
        ModTerminaContrato,
    },
    data: () => ({
        numContrato : '',
        listContratos : [],
        listTipoContrato : [],
        listTercero : [],
        listTipoAct : [],
        listActivo : [],
        // showCreaContrato : false,
        showDetalleContrato : false,
        showModTermContracto : false,
        detailContrato : [],
        perPage: 500,
        currentPage: 1,
        filtroContrato: '',
        fields: [
            { key: 'nro_contrato', label: 'Contrato', sortable: false },
            { key: 'identificacion', label: 'Arrendador', sortable: false },
            { key: 'tipo_contrato', label: 'Tipo contrato', sortable: false },
            { key: 'valor_contrato', label: 'Valor contrato', sortable: false },
            { key: 'fecha_inicial', label: 'Fecha inicial', sortable: false },
            { key: 'fecha_final', label: 'Fecha final', sortable: false },
            { key: 'estado', label: 'Estado', sortable: false },
        ]
    }),
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){
                return {
                    title : 'Lista Contratos',
                    noRow : "No hay registros",
                    nroContrato : "Nro.",
                    arrendador : 'Arrendador',
                    fechaActivacion : 'Fecha activación',
                    fechaInicial : 'Fcha Inicial',
                    fechaFinal : 'Fecha Final',
                    tipoContrato : 'Tipo Cntr',
                    valorContrato : 'Valor Cntrto',
                    estado : 'Estato'
                }
            }else{
                return {
                    title : 'Contracts list',
                    noRow : "There are not records",
                    nroContrato : "Contract number",
                    arrendador : 'Lessor',
                    fechaActivacion : 'Activation date',
                    fechaInicial : 'Strating date',
                    fechaFinal : 'End date',
                    tipoContrato : 'Contract type',
                    valorContrato : 'Contract value',
                    estado : 'State'
                }
            }
        },
        filteredRows() {
            // Devuelve cuántos registros hay luego de aplicar el filtro
            return this.listContratos.filter(item =>
                item.nro_contrato.toString().includes(this.filtroContrato)
            ).length
        }
    },
    methods:{
        // createContrato(){
        //     this.showCreaContrato = true
        // },
        formatNumber(value) {
            return new Intl.NumberFormat('es-CO', { minimumFractionDigits: 0, maximumFractionDigits: 3 }).format(value);
        },
        filtrarPorContrato(item, filtro) {
            if (!filtro) return true
            const texto = filtro.toString().toLowerCase()
            return item.nro_contrato.toString().toLowerCase().includes(texto)
        },
        detalleContrato(id,nroContrato){

            if(this.$route.name == 'terminacioncontrato'){
                this.showModTermContracto = true
                this.numContrato = nroContrato
            
            }else if(this.$route.name == 'consultarcontrato'){

                Contrato.getContratoById(id)
                .then((res) => {
                    this.detailContrato = res.data.contractById[0]
                    this.showDetalleContrato = true
                })
                .catch((err) => console.log(err))
            }

        },
	showArrendador(identify){
		if	(identify == null || identify == undefined) {
			return identify
		}
		let nameTercero = this.listTercero.find((tercer) => tercer.identificacion === identify)

		if	(nameTercero == undefined) {
			return "Sin Nombre "+identify
		}
		return nameTercero.nombre
	},
        showTipoContrato(tipContrato){
		if	(tipContrato == null || tipContrato == undefined) {
			return tipContrato
		}
            let tipoContrato = this.listTipoContrato.find((tipoContact) => tipoContact.tipo_contrato === tipContrato)
            return tipoContrato.descripcion
        },
        closeModal(val){
            // this.showCreaContrato = val
            this.showDetalleContrato = val
            this.showModTermContracto = val
        }
    },
    mounted(){
        Contrato.getAllContratos()
        .then((res) => {
            this.listContratos = res.data.listContratos
        })
        .catch((err) => console.log(err))

        Tercero.getAllTercero()
        .then((res) => {
            this.listTercero = res.data.listTercero
        })
        .catch((err) => console.log(err))

        TipoContrato.getAllTipoContrato()
        .then((res) => {
            this.listTipoContrato = res.data.listTipoContrato
        })
        .catch((err) => console.log(err))
    }
}
</script>
<style src="../main.css">
</style>
